import Grid from '@material-ui/core/Grid'
import React from 'react'

const SubSection = ({ response: { childSections, nodes }, setParentId, parentId, expandedSection }) => {
  const handleOnChange = ({ target: { value } }) => setParentId(value)

  return (
    <Grid item xs={12}>
      <Grid container className='w-100 bg-precedents-blue-10 b pa6'>
        <Grid item xs={3}>
          <label htmlFor='parentId'>Sub-Section</label>
        </Grid>
        <Grid item xs={9} className='pl8'>
          <select
            name='parentId'
            value={parentId || expandedSection || ''}
            onChange={handleOnChange}
            className='menu-list-button'
          >
            {!parentId && <option value='' disabled> Select value </option>}
            {childSections && childSections.map(id => (
              <option key={id} value={id}>
                {nodes[id].title}
              </option>)
            )}
          </select>
        </Grid>
      </Grid>
    </Grid>
  )
}

export default SubSection
